/**
 * auth页面分发器
 */
import router from '../../router'
import conf from '../../conf/wx.conf'

class AuthPageDisperser {
  constructor () { }
  action (params) {
    const { state = {} } = params
    const routeList = router.options.routes
    const query = {}
    for (const key in state) {
      if (state.hasOwnProperty(key) && key !== 'page') {
        query[key] = state[key]
      }
    }
    const page = routeList.find(item => item.name === state.page) ? state.page : conf.DEFAULT_NAVIGATE_PAGE
    router.replace({
      query,
      name: page
    })
  }
}

export default AuthPageDisperser
